import { useApi } from '@/common/ApiHelper';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { ConditionOperator, LogicalOperator } from '@sysarb/sysarb-api/models/common/selection/Selection';
import type Employment from '@sysarb/sysarb-api/models/entities/Employment';
import { Statuses } from '@sysarb/sysarb-api/models/entities/Employment';
import type { QueryOptions } from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';
import { resolveSectionManagerNodeIds } from './organisationNodeHelpers';

type LegacyEmploymentsOptions = {
    queries: {
        /** Active employments for the section manager's node and all descendant nodes (legacy Employment entity). */
        getLegacyEmployments: () => QueryOptions<Employment[], Error>;
    };
};

export const legacyEmployments: LegacyEmploymentsOptions = {
    queries: {
        getLegacyEmployments: (): QueryOptions<Employment[], Error> => {
            const { currentOrganisationNodeId } = useLoginStore();

            return queryOptions<Employment[], Error>({
                queryKey: ['section-manager', 'legacy-employments', currentOrganisationNodeId],
                queryFn: async (): Promise<Employment[]> => {
                    const api = useApi();
                    const nodeIds = await resolveSectionManagerNodeIds(api, currentOrganisationNodeId);
                    if (nodeIds.length === 0) return [];

                    return api.employment.getBySelection({
                        Condition: {
                            LogicalOperator: LogicalOperator.And,
                            Conditions: [
                                {
                                    PropertyName: 'OrganisationNode_ID',
                                    ConditionOperator: ConditionOperator.In,
                                    Value: nodeIds,
                                },
                                {
                                    PropertyName: 'Status_Value',
                                    ConditionOperator: ConditionOperator.EqualTo,
                                    Value: Statuses.active,
                                },
                            ],
                        },
                    });
                },
                enabled: () => currentOrganisationNodeId != null,
            });
        },
    },
};
